import axios from 'axios'
import { useCallback } from 'react'
import { useState, useEffect } from 'react'
import { API_URL, BACKEND_URL } from 'utils/apiConstants'

const useFetchAllCompanies = () => {
  const [companies, setCompanies] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  const fetchAllCompanies = useCallback(async () => {
    try {
      let url = BACKEND_URL + API_URL.banner.allCompanies
      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      })

      // Extract company titles, filter out undefined/null/empty, remove duplicates and sort alphabetically
      const companyTitles = response.data
        ?.filter((company) => company?.title && typeof company.title === 'string' && company.title.trim().length > 0)
        .map((company) => ({ title: company.title.trim() })) || []
      
      // Remove duplicates based on title
      const uniqueCompanies = Array.from(
        new Map(companyTitles.map(item => [item.title.toLowerCase(), item])).values()
      )
      
      // Sort alphabetically
      const sortedCompanies = uniqueCompanies.sort((a, b) => 
        a.title.localeCompare(b.title, undefined, { sensitivity: 'base' })
      )

      setCompanies(sortedCompanies)
      setLoading(false)
    } catch (error) {
      setError(error)
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    fetchAllCompanies()
  }, [fetchAllCompanies])

  return { companies, loading, error, refetch: fetchAllCompanies, setCompanies }
}

export default useFetchAllCompanies
